import { TopLeaguesRetriever } from "../TopLeaguesRetriever";
import { CouponLeaguesRetriever } from "../CouponLeaguesRetriever";
import { AllLeaguesRetriever } from "../AllLeaguesRetriever";
var RetrieverChooser = /** @class */ (function () {
    function RetrieverChooser(bffGateway, dataProvider, loadedData) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.loadedData = loadedData;
    }
    RetrieverChooser.prototype.selectRetriever = function (sportId, leagueIds) {
        if (sportId === void 0) { sportId = "0"; }
        if (leagueIds === void 0) { leagueIds = []; }
        this.dataProvider.sportId = sportId;
        this.dataProvider.leagueIds = leagueIds;
        if (this.dataProvider.leagueIds.length) {
            return new CouponLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
        }
        if (this.dataProvider.isTopLeaguesOnly) {
            return new TopLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
        }
        return new AllLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
    };
    return RetrieverChooser;
}());
export { RetrieverChooser };
//# sourceMappingURL=RetrieverChooser.js.map